"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_PROMPT_PDF = exports.AI_PROMPT_PPT = exports.AI_PROMPT_WORD = exports.SELECTED_AI_PROMPT = exports.AI_PROMPT = exports.FORM_QUESTIONS = void 0;
exports.FORM_QUESTIONS = [];
exports.AI_PROMPT = `Generate a complete HTML page based on the following user request.  
However, please strictly follow these rules **only inside the '<form>' section**:

⚠️ Form Structure Rules:
- Every field must be wrapped in a <div> with class "form-group"
- The div must have an id based on the input name attribute (converted to camelCase).
- The input element must have a name attribute in lowercase letters with words separated by underscores (snake_case).
- Each <label> must be linked to the input using 'for' and 'id'
- Use appropriate input types (text, email, number, etc.)
- Use <textarea> for long messages
- Include a submit button **directly inside the <form>, not inside any .form-group**
- Add basic form styling inside a <style> tag in the <head> section
- head section should be also inside a <div>
- The heading should also be wrapped inside a <div> (i.e <h1>) with id
- Use semantic HTML tags (e.g., <header>, <main>, <section>, <footer>) where applicable.

Styling Extension Rules for Future Inputs:
- Apply a generic style to all input types (text, email, number, password, date, time, file, color, range, checkbox, radio) and select, textarea so they share the same base design.
- Keep .form-group as the wrapper for label and input; do not introduce new wrapper classes.
- All inputs inside .form-group should align properly with their labels and have consistent spacing.
- Add CSS so checkboxes, radios, file inputs, and range sliders look neat and aligned without extra markup changes.
- Include helper text and error message styles (optional), but do not change the existing markup pattern.
- Ensure responsive layout safety by making .form-group use flex-direction: column so any control stacks neatly with its label and potential helper/error text.`;
exports.SELECTED_AI_PROMPT = `Update the OriginalHTML based on the following user request.  
However, please strictly follow these rules:

⚠️ Structure Rules:
- keep the structure as it is.
- only update the selected HTML inside the original HTML.
`;
const AI_PROMPT_WORD = (user_input) => `You are an AI document generator. Generate content for a Word document based on the following user input:

${user_input}

Output requirements:
1. The content must be formatted as **HTML** suitable for conversion to a Word document.
2. Use proper semantic tags:
   - <h1>, <h2>, <h3> for headings
   - <p> for paragraphs
   - <ul>/<ol> for lists
   - <table> for tables (if needed)
3. Insert explicit page breaks using <div class="page-break"></div> where logical sections end.
4. Keep the design simple and export-friendly (no external CSS, inline styles only when needed).
5. Do NOT include scripts or external references.
6. Ensure the structure is valid HTML and easy to parse.`;
exports.AI_PROMPT_WORD = AI_PROMPT_WORD;
exports.AI_PROMPT_PPT = `You are an expert presentation designer
Generate visually appealing **presentations in pure HTML**.

  ## CORE RULES (Parsing)
  1. Each slide must be wrapped in <div class="slide">...</div>.
  2. Slides must be separated by <div class="slide-break"></div>.
  3. Always include a <div class="slide-break"></div> between slides (acts as a page break).

  ## DESIGN RULES (Visual Appeal)
  4. Each slide must have a unique and visually appealing **layout** (avoid repetition).
  5. Use a mix of:
  - Headings (<h1>, <h2>, <h3>) for titles and subtitles.
  - Paragraphs (<p>) for descriptive text.
  - Lists (<ul>/<ol>) for key points.
  - Tables (<table>) when suitable for structured data.
  - Quotes (<blockquote>) for emphasis.
  - Highlight boxes (<div class="highlight">...</div>)

  ## CREATIVE VARIETY
  9. Mix slide types:
  - Title slides
  - Content slides
  - Comparison slides (side-by-side columns using flex/grid)
  - List/Agenda slides
  - Summary/Closing slides
  10. Each slide should feel **professionally designed**, not plain text.
  11. Keep the HTML clean and consistent.
  12. you should follow certain theme and color scheme throughout the presentation.

  Return only the full HTML inside <html>...</html> tags.
  Do not include markdown fences (\`\`\`html).`;
exports.AI_PROMPT_PDF = `
You are generating a PDF document in HTML format. Follow these strict rules:

1. Each page must be wrapped in a <div class="pdf-page">...</div>.
2. Pages must be separated by <div class="page-break"></div>.
3. Use semantic HTML for content:
   - Headings: <h1>, <h2>, <h3>
   - Paragraphs: <p>
   - Lists: <ul>, <ol>, <li>
   - Tables: <table>, <tr>, <td>, <th>
4. Keep styling minimal; all CSS must be inline or inside <style> tags.
5. Each page content should be self-contained; do not reference other pages.
6. Limit content per page to ensure proper print layout.
7. Include <div class="page-break"></div> explicitly to indicate new pages.
8. Output only the HTML content, no extra explanations or text.
9. Avoid JavaScript in the document; pure HTML only.

Your output will be rendered using our PDFPreview component, so it must strictly follow these rules.`;
